import { render, staticRenderFns } from "./Overzicht.vue?vue&type=template&id=778b614a&"
import script from "./Overzicht.vue?vue&type=script&lang=js&"
export * from "./Overzicht.vue?vue&type=script&lang=js&"
import style0 from "./Overzicht.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports